{
   "admin" : {
      "index_view" : {
         "actions" : {
            "log_in" : "Anmelden",
            "log_out" : "Abmelden"
         },
         "message" : {
            "logged_in" : "Aktuell angemeldet als {name}.",
            "not_logged_in" : "Sie sind derzeit nicht mit dem Administratorkonto angemeldet."
         },
         "title" : "Digital signage"
      },
      "language_names" : {
         "english" : "Englisch",
         "german" : "Deutsch"
      },
      "login_view" : {
         "actions" : {
            "back_to_login" : "Zurück zur Anmeldung",
            "change_user" : "Benutzer wechseln",
            "corporate_login" : "Unternehmenskonto",
            "login" : "Anmelden"
         },
         "controls" : {
            "email" : "E-Mail",
            "password" : "Passwort"
         },
         "labels" : {
            "are_you_not_user" : "Nicht {user}?",
            "external_auth" : {
               "checking" : "Verarbeite...",
               "failed" : "Anmeldung fehlgeschlagen, bitte erneut versuchen.",
               "inuse" : "Dieses Benutzerkonto ist bereits mit einem anderen any2any Benutzerkonto verlinkt. Bitte versuchen Sie sich, mit diesem Benutzerkonto anzumelden.",
               "preparing" : "Authentifizierung wird vorbereitet...",
               "start" : "Weiterleitung zum Authentifizierungsanbieter ...",
               "user_exists_not_linked" : "Leider konnte die Anmeldung nicht erfolgreich abgeschlossen werden, da bereits ein Benutzer mit diesen Daten existiert. Bitte erst über das any2any Benutzerkonto einloggen und mit dem Firmen Zugang verknüpfen. Danach funktioniert die Firmenanmeldung wie erwartet."
            },
            "provider_category" : {
               "corporate" : "Verwenden Sie Ihr Unternehmenskonto",
               "internal" : "Mit E-Mail und Passwort anmelden"
            }
         },
         "title" : {
            "default" : "Digitale Beschilderung",
            "external_auth" : "Firmenanmeldung",
            "page_title" : "Anmelden"
         }
      },
      "pairing_view" : {
         "actions" : {
            "cancel" : "Abbrechen",
            "retry" : "Erneut versuchen"
         },
         "steps" : {
            "display_information" : {
               "actions" : {
                  "proceed" : "Fortfahren"
               },
               "fields" : {
                  "description" : "Display Beschreibung",
                  "name" : "Display name"
               },
               "message_input_information" : "Bitte geben Sie die erforderlichen Informationen zum Display ein",
               "title" : "Displayinformationen"
            },
            "layout_selection" : {
               "actions" : {
                  "proceed" : "Fortfahren"
               },
               "errors" : {
                  "resolving" : "Beim Auflösen der Layoutdaten ist ein Fehler aufgetreten."
               },
               "message" : {
                  "click_to_proceed" : "Klicken Sie auf die Schaltfläche unterhalb der Tabelle, um fortzufahren.",
                  "select_layout" : "Wählen Sie das Layout aus, das dem Display zugewiesen werden soll. Dieser Schritt ist optional."
               },
               "search_placeholder" : "Suche nach einem Layout...",
               "table" : {
                  "grid_size" : "Rastergröße",
                  "name" : "Name",
                  "no_layouts_found_message" : "Kein Layout gefunden",
                  "widgets" : "Widgets"
               },
               "title" : "Layout auswahl"
            },
            "location_selection" : {
               "actions" : {
                  "proceed" : "Fortfahren"
               },
               "errors" : {
                  "resolving" : "Beim Auflösen der Gebäudedaten ist ein Fehler aufgetreten"
               },
               "message" : {
                  "click_to_proceed" : "Klicken Sie auf die Schaltfläche unter der Tabelle, um fortzufahren",
                  "select_location" : "Wählen Sie ein Gebäude aus, indem Sie auf die entsprechende Zeile klicken"
               },
               "search_placeholder" : "Nach Gebäude suchen",
               "table" : {
                  "address" : "Adresse",
                  "name" : "Name",
                  "name_and_address" : "Name und Adresse"
               },
               "title" : "Gebäude auswahl"
            },
            "printer_config" : {
               "actions" : {
                  "proceed" : "Fortfahren"
               },
               "form" : {
                  "brother_model_name" : "Modell",
                  "brother_serial" : "Seriennummer",
                  "channel" : "Kanal",
                  "enabled" : "Eingeschaltet"
               },
               "message" : {
                  "click_to_proceed" : "Klicken Sie auf die Schaltfläche unten, um fortzufahren.",
                  "configure_printer" : "Druckerkonfiguration"
               },
               "title" : "Druckerkonfiguration"
            },
            "result" : {
               "actions" : {
                  "logout" : "Abmelden"
               },
               "errors" : {
                  "pairing" : "Beim Koppeln des Geräts ist ein Fehler aufgetreten"
               },
               "message_pairing_in_progress" : "Kopplung läuft, bitte warten...",
               "message_pairing_success" : "Das Display wurde erfolgreich mit dem Gebäude gekoppelt. Sie können diese Seite jetzt verlassen.",
               "title" : "Ergebnis"
            },
            "summary" : {
               "actions" : {
                  "pair" : "Display mit Gebäude koppeln"
               },
               "message" : {
                  "printer_config" : "Druckerkonfiguration: {enabled}",
                  "selected_display_description" : "Display Beschreibung: {description}",
                  "selected_display_name" : "Display name: {name}",
                  "selected_layout" : "Ausgewähltes Layout: {name}",
                  "selected_location" : "Gewähltes Gebäude: {name}"
               },
               "title" : "Zusammenfassung"
            },
            "verification" : {
               "errors" : {
                  "invalid_pairing_data" : "Ungültige Kopplungsdaten, Authentifizierung beim Server nicht möglich",
                  "unauthorized" : "Sie verfügen nicht über die erforderliche Berechtigung, um diesen Vorgang auszuführen"
               },
               "message" : "Sammeln und Überprüfen notwendiger Informationen...",
               "title" : "Überprüfung"
            }
         },
         "title" : "Displaykopplung"
      },
      "profile_menu" : {
         "actions" : {
            "logout" : "Abmelden"
         }
      }
   },
   "common" : {
      "actions" : {
         "cancel" : "Abbrechen",
         "confirm" : "Bestätigen"
      },
      "page_title" : {
         "suffix" : "any2any Digitale Beschilderung"
      },
      "qrcode_scanner" : {
         "errors" : {
            "no_cameras" : "Keine Kameras gefunden",
            "no_permissions" : "Sie müssen Berechtigungen für den Zugriff auf eine Kamera erteilen"
         }
      },
      "states" : {
         "disabled" : "Ausgeschaltet",
         "enabled" : "Eingeschaltet"
      },
      "validation_errors" : {
         "required" : "Eine Eingabe ist erforderlich"
      }
   },
   "initialization" : {
      "message" : "Bitte warten...",
      "title" : "Initialisierung"
   },
   "maintenance" : {
      "actions" : {
         "go_back" : "Zurück",
         "reset_all_and_reload" : "Setzen Sie alle gespeicherten Daten zurück und gehen Sie zurück",
         "restore_credentials" : "Gespeicherte Anmeldeinformationen wiederherstellen",
         "store_credentials" : "Bewahren Sie Ihre Anmeldedaten für später auf"
      },
      "title" : "Wartungspanel"
   },
   "page404" : {
      "countdown_message" : "Diese Seite wird in {seconds} Sekunden geschlossen",
      "message" : "Wir konnten nicht finden, was Sie gesucht haben.",
      "title" : "404"
   },
   "pairing" : {
      "qrcode_card" : {
         "message" : "Scannen Sie den QR-Code auf einem anderen Gerät, um mit der Kopplung fortzufahren.",
         "title" : "Koppeln Sie Ihr Display"
      }
   },
   "signage" : {
      "badge_print_process" : {
         "status" : {
            "failure" : "Druckvorgang fehlgeschlagen, siehe weitere Informationen unten",
            "in_progress" : "Ihr Ausweis wird gedruckt, bitte warten Sie...",
            "initializing" : "Initialisierung des Ausweisdrucks...",
            "pending" : "Der Druckvorgang steht noch aus.",
            "success" : "Ihr Ausweis wurde erfolgreich gedruckt."
         },
         "status_code" : "Fehlercode",
         "timeout_message" : "Der Druckvorgang hat zu lange gedauert, bitte versuchen Sie es erneut."
      },
      "error_view" : {
         "errors" : {
            "unauthorized" : "Das Display ist nicht autorisiert",
            "undefined_layout" : "Dem Display ist keine Gestaltung zugewiesen",
            "unknown" : "Wir wissen nicht, was passiert ist, tut mir leid"
         },
         "redirecting_in_seconds" : "Umleitung in {seconds} Sekunden",
         "title" : "Etwas ist schief gelaufen",
         "trying_again_in_seconds" : "Erneuter Versuch in {seconds} Sekunden"
      },
      "information_modal" : {
         "countdown_information" : "Dieses Fenster wird in {seconds} Sekunden automatisch geschlossen"
      },
      "layout_view" : {
         "title" : "Digitale Beschilderung"
      },
      "printers_list_modal" : {
         "channel" : "Kanal",
         "model" : "Modell",
         "no_printers_discovered" : "Keine Drucker gefunden",
         "provider" : "Anbieter",
         "serial" : "Seriennummer",
         "title" : "Liste der gefundenen Drucker"
      },
      "qrcode_action_failure_modal" : {
         "action_not_supported" : "Vorgang wird nicht unterstützt",
         "action_timed_out" : "Zeitüberschreitung beim Vorgang. Bitte versuchen Sie es erneut",
         "checked_in" : "Leider unterstützt dieses Terminal keine Selbst-Check-Ins",
         "checked_out" : "Leider unterstützt dieses Terminal keine Self-Checkouts",
         "different_qrcode_message" : "Der QR-Code war anders als der Ursprüngliche",
         "not_recognized_message" : "QR-Code wurde nicht erkannt",
         "title" : "Etwas ist schief gelaufen"
      },
      "qrcode_action_success_modal" : {
         "checked_in" : {
            "message" : "Ihr Gastgeber {hostName} wird darüber informiert, dass Sie angekommen sind und sich im Gebäude befinden",
            "title" : "Vielen Dank fürs Einchecken"
         },
         "checked_out" : {
            "message" : "Das Auschecken war erfolgreich, wir wünschen Ihnen einen schönen Tag!",
            "title" : "Vielen Dank für Ihren Besuch"
         }
      },
      "qrcode_confirmation_modal" : {
         "action_label" : {
            "checked_in" : "Zum Einchecken",
            "checked_out" : "Zum Auschecken",
            "please_wait" : "Bitte warten"
         },
         "countdown_message" : "Bitte scannen Sie Ihren QR-Code innerhalb der nächsten {seconds} Sekunden erneut",
         "title" : {
            "with-name" : "Willkommen, {name}",
            "without-name" : "Willkommen"
         }
      },
      "widgets" : {
         "header" : {
            "weather" : {
               "description" : {
                  "broken_clouds" : "Bewölkt",
                  "clear_sky" : "Klarer Himmel",
                  "few_clouds" : "Vereinzelte Wolken",
                  "mist" : "Nebel",
                  "rain" : "Regen",
                  "scattered_clouds" : "Leichte Bewölkung",
                  "shower_rain" : "Regenschauer",
                  "snow" : "Schnee",
                  "thunderstorm" : "Gewitter"
               }
            }
         },
         "metric" : {
            "enabled_value" : {
               "co2" : "CO2",
               "humidity" : "Luftfeuchtigkeit",
               "illumination" : "Beleuchtung",
               "occupancy" : "Belegung",
               "people_count" : "Personenzahl",
               "rssi" : "RSSI",
               "temperature" : "Temperatur"
            }
         },
         "qrcode_scanner" : {
            "message" : "Bitte scannen Sie Ihren QR-Code und platzieren Sie ihn im Rahmen der Kamera",
            "title" : "QR-Code-Scanner"
         },
         "room_status" : {
            "availability_text" : {
               "available" : "Verfügbar",
               "available_at" : "Verfügbar ab {time}",
               "available_till" : "Verfügbar bis {time}"
            }
         }
      }
   }
}
